<template>
  <BaseScreen v-bind="screen">
    <BaseAlert
      v-if="isThanksVisible"
      v-bind="thanks"
      slot="middle"
    />
    <BaseAlert
      v-if="isErrorVisible"
      v-bind="error"
      slot="middle"
    />
    <Instruction
      v-bind="instruction"
      class="screen__stretch screen__offset-right"
    />
  </BaseScreen>
</template>

<script>
import CONSTANTS from '@/helpers/constants';

import screenMixin from '@/mixins/screen';
import qrMixin from '@/mixins/qr';

import Instruction from '@/components/Instruction.vue';

export default {
  name: 'QRScreen',
  mixins: [screenMixin, qrMixin],
  components: {
    Instruction,
  },
  data() {
    return {
      isScannerReady: false,
      scanResult: null,
    };
  },
  staticData: () => ({
    redirectTimeout: null,
  }),
  computed: {
    pendingText() {
      return this.isScannerReady
        ? this.$t('pending.scan')
        : this.$t('pending.hardware');
    },
    screenCase() {
      if (this.isThanksVisible) {
        return this.scanResult
          ? CONSTANTS.STEP_SCAN_FINISH
          : CONSTANTS.STEP_SCAN_FAILED;
      }
      if (this.isErrorVisible) {
        return CONSTANTS.STEP_QR_ERROR;
      }
      if (this.isScannerReady) {
        return CONSTANTS.STEP_SCAN_QR;
      }
      return null;
    },
    instruction() {
      return {
        description: {
          text: this.$t('texts.scanQr'),
          size: 'l',
        },
        imageName: 'qr.jpg',
      };
    },
    thanks() {
      return this.scanResult
        ? this.goodScan
        : this.badScan;
    },
    goodScan() {
      return {
        icon: {
          name: 'success',
          theme: 'primary',
          size: 'l',
        },
        title: {
          text: this.$t('titles.scanReady'),
          size: 'l',
        },
        actions: [],
      };
    },
    badScan() {
      return {
        icon: {
          name: 'important',
          theme: 'secondary',
          size: 'l',
        },
        title: {
          text: this.$t('titles.scanFailed'),
          size: 'l',
        },
        actions: [
          {
            text: this.$t('actions.home'),
            action: this.goToHomeScreen,
            view: 'outlined',
          },
          {
            text: this.$t('actions.retry'),
            action: this.retryScan,
          },
        ],
      };
    },
    error() {
      return {
        icon: {
          name: 'important',
          theme: 'secondary',
          size: 'l',
        },
        title: {
          text: this.$t('titles.badHardware'),
          size: 'l',
        },
        description: {
          text: this.$t('texts.scanNotPossible'),
          size: 'l',
        },
        actions: [
          {
            text: this.$t('actions.home'),
            action: this.goToHomeScreen,
            view: 'outlined',
          },
          {
            text: this.$t('actions.enterPersonal'),
            action: this.goToSignInScreen,
          },
        ],
      };
    },
  },
  beforeDestroy() {
    this.clearRedirectTimeout();
  },
  created() {
    this.showPending(0);
    this.initActions([
      [CONSTANTS.ACTION_SIGN_IN, this.goToSignInScreen],
      [CONSTANTS.ACTION_RETRY, this.retryScan],
    ]);
  },
  methods: {
    onScannerConnected(isConnected) {
      // Этот колбек будет вызван из миксина, после подключения к считывателю штрих-кодов
      this.isScannerReady = Boolean(isConnected);
      if (!isConnected) {
        this.showError();
      } else {
        this.hidePending();
      }
    },
    onScanFinish(result) {
      console.log('barcodeService.onResult: ', result);
      // Этот колбек будет вызван из миксина, после сканирования
      if (result) {
        const fields = result.split('|').reduce((acc, el) => {
          const [name, value] = el.split('=');
          return { ...acc, [name]: (value || '').trim() };
        }, {});
        this.scanResult = fields.PersAcc;
        if (this.scanResult) {
          this.redirectTimeout = window.setTimeout(this.goToBalanceScreen, 2000);
        }
      } else {
        this.scanResult = null;
      }
      this.showThanks();
    },
    retryScan() {
      this.hideThanks();
    },
    clearRedirectTimeout() {
      window.clearTimeout(this.redirectTimeout);
    },
    goToBalanceScreen() {
      return this.$router.push({
        path: this.$router.options.paths.guestBalance,
        query: {
          account: this.scanResult,
        },
      });
    },
    goToSignInScreen() {
      this.$router.push(this.$router.options.paths.signIn);
    },
  },
};
</script>
